import ApplicationAdapter from './application';

export default class EmployeeVisitMetricsAdapter extends ApplicationAdapter {
  pathForType() {
    return 'employee-visit-metrics';
  }
}
